function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
var StyledText = styled.div(_templateObject(), function (props) {
  return props.theme.fontWeight[props.variant];
}, function (props) {
  return props.theme.text[props.color];
}, function (props) {
  return props.theme.typeScale[props.size];
});

var Text = function Text(_ref) {
  var text = _ref.text,
      color = _ref.color,
      size = _ref.size,
      variant = _ref.variant,
      referenceClass = _ref.referenceClass,
      rest = _objectWithoutPropertiesLoose(_ref, ["text", "color", "size", "variant", "referenceClass"]);

  return /*#__PURE__*/React.createElement(StyledText, _extends({}, rest, {
    color: color,
    size: size,
    variant: variant,
    className: referenceClass || ''
  }), text);
};

Text.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  referenceClass: PropTypes.string
} : {};
Text.defaultProps = {
  type: 'primary',
  size: 'regular',
  variant: 'primary',
  color: 'default',
  referenceClass: '',
  theme: defaultTheme
};
export default Text;